export default "__VITE_ASSET__b1f38aa0__"